<div
	class="notification-topbar d-flex justify-content-between align-items-center p-2"
	*ngIf="hasToolbar"
>
	<strong> {{ title | translate }} </strong>
	<div class="buttonset" >
		<button
			pButton
			*ngIf="all"
			(click)="close()"
			[routerLink]="['/notifications']"
			[label]="('notifications.all' | translate ) + '&nbsp;' "
			icon="fa fa-list"
			class="p-button-text p-button-sm p-button-secondary"
		></button>

		<button
			pButton
			[matTooltip]="'notifications.markAllAsRead' | translate"
			[matTooltipPosition]="'before'"
			(click)="markAllAsRead()"
			icon="fa fa-check"
			class="p-button-text p-button-sm p-button-secondary"
		></button>
	</div>
</div>

<div text-center padding [hidden]="notifications?.length > 0">
	<ion-text>
		<h6 padding class="no-data">{{ 'notifications.noEntry' | translate }}</h6>
	</ion-text>
</div>
<ion-content [className]="'ion-content'" appScrollbarTheme>
	<ion-virtual-scroll
		[className]="'scroll-area'"
		[headerFn]="compareDate"
		[trackBy]="trackBy"
		[items]="notifications"
	>
		<ion-item-divider *virtualHeader="let header">
			{{ header | translate }}
		</ion-item-divider>
		<div *virtualItem="let notification">
			<app-notification-item
				(click)="handleOpen(notification)"
				[routerLink]="['/requests/details/' + notification.sourceId]"
				[notification]="notification"
				(notificationAction)="onNotificationAction($event)"
			>
			</app-notification-item>
		</div>
	</ion-virtual-scroll>

	<ion-infinite-scroll dir="ltr" margin-top (ionInfinite)="fetchMore($event)" threshold="4.5rem">
		<ion-infinite-scroll-content
			loadingSpinner="bubbles"
			[loadingText]="'notifications.more' | translate"
		>
		</ion-infinite-scroll-content>
	</ion-infinite-scroll>
</ion-content>
